module.exports = __webpack_public_path__ + "static/media/star.e26df9e5.svg";